import { useLocalization } from "@fluent/react";
import type { ProductType } from "@lending/navigation";

interface ProductTypeContent {
  name: string;
  productSelectionSubtext: string;
  sidebarSubtext: string;
}

function toSentenceCase(text: string) {
  if (text.length === 0) {
    return text;
  }

  const lowerText = text.toLocaleLowerCase();
  return `${lowerText[0].toLocaleUpperCase()}${lowerText.slice(1)}`;
}

function useProductTypeContent(): Record<ProductType, ProductTypeContent> {
  const { l10n } = useLocalization();

  const autoLoanSubtext = l10n.getString(
    "product-selection-auto-loan-subtext",
    null,
    "NEW AND USED"
  );
  const creditCardSubtext = l10n.getString(
    "product-selection-credit-card-subtext",
    null,
    "UP TO 2% CASH BACK"
  );
  const personalLoanSubtext = l10n.getString(
    "product-selection-personal-loan-subtext",
    null,
    "BORROW UP TO $40,000"
  );

  return {
    "auto-loan": {
      name: l10n.getString("product-selection-auto-loan-name", null, "Auto loan"),
      productSelectionSubtext: autoLoanSubtext,
      sidebarSubtext: toSentenceCase(autoLoanSubtext),
    },
    "credit-card": {
      name: l10n.getString("product-selection-credit-card-name", null, "Credit card"),
      productSelectionSubtext: creditCardSubtext,
      sidebarSubtext: toSentenceCase(creditCardSubtext),
    },
    "personal-loan": {
      name: l10n.getString("product-selection-personal-loan-name", null, "Personal loan"),
      productSelectionSubtext: personalLoanSubtext,
      sidebarSubtext: toSentenceCase(personalLoanSubtext),
    },
  };
}

export { useProductTypeContent };
